// JavaScript Document
( function( $ ) {
  $('#round').val(getUrlParam('round', ''));  
  $('#division').val(getUrlParam('division', ''));
  $('#team').val(getUrlParam('team', ''));
  function getUrlVars() {
    var vars = {};
    var parts = window.location.href.replace(/[?&]+([^=&]+)=([^&]*)/gi, function(m,key,value) {
        vars[key] = value;
    });
    return vars;
  }
  function getUrlParam(parameter, defaultvalue){
    var urlparameter = defaultvalue;
    if(window.location.href.indexOf(parameter) > -1){
        urlparameter = getUrlVars()[parameter].replace(/\+/gi, ' ');
        }
    return urlparameter;
  }
	
  // Add smooth scrolling to all links
  $("#scrolldown").on('click', function(event) {
    
    // Make sure this.hash has a value before overriding default behavior
    if (this.hash !== "") {
      // Prevent default anchor click behavior
      event.preventDefault();

      // Store hash
      var hash = this.hash;

      // Using jQuery's animate() method to add smooth page scroll
      // The optional number (800) specifies the number of milliseconds it takes to scroll to the specified area
      $('html, body').animate({
        scrollTop: $(hash).offset().top
      }, 800, function(){
   
        // Add hash (#) to URL when done scrolling (default click behavior)
        window.location.hash = hash;
      });
    } // End if
   
  });
	
  // Add map tab
  function map_init()
  {
	  $("#__map_description_1").css("display","none");
	  $("#__map_description_2").css("display","none");
	  $("#__map_description_3").css("display","none");
	  $("#__map_description_4").css("display","none");
	  $("#__map_description_5").css("display","none");
	  $("#__map_description_6").css("display","none");
	  $("#__map_frame_1").css("display","none");
	  $("#__map_frame_2").css("display","none");
	  $("#__map_frame_3").css("display","none");
	  $("#__map_frame_4").css("display","none");
	  $("#__map_frame_5").css("display","none");
	  $("#__map_frame_6").css("display","none");
  }
  map_init();
  $("#__map_description_1").css("display","block");
  $("#__map_frame_1").css("display","block");   
  $("#__map_1").on('click', function(event) {    
    map_init();
	$("#__map_description_1").css("display","block");
	$("#__map_frame_1").css("display","block");   
  });
	
  $("#__map_2").on('click', function(event) {    
    map_init();
    $("#__map_description_2").css("display","block");
	$("#__map_frame_2").css("display","block");   
  });
	
  $("#__map_3").on('click', function(event) {    
    map_init();
    $("#__map_description_3").css("display","block");
	$("#__map_frame_3").css("display","block");   
  });
	
  $("#__map_4").on('click', function(event) {    
    map_init();
    $("#__map_description_4").css("display","block");
	$("#__map_frame_4").css("display","block");   
  });
	
  $("#__map_5").on('click', function(event) {    
    map_init();
    $("#__map_description_5").css("display","block");
	$("#__map_frame_5").css("display","block");   
  });
	
  $("#__map_6").on('click', function(event) {    
    map_init();
    $("#__map_description_6").css("display","block");
	$("#__map_frame_6").css("display","block");   
  });
	
  // Add map tab
  function stories_init()
  {	  
	  $("#__stories_1").removeClass("__active");
	  $("#__stories_2").removeClass("__active");
	  $("#__stories_3").removeClass("__active");
	  $("#__stories_4").removeClass("__active");
	  $("#__stories_5").removeClass("__active");
	  $("#__stories_6").removeClass("__active");
	  $("#__stories_7").removeClass("__active");
	  $("#__stories_8").removeClass("__active");
	  $("#__stories_9").removeClass("__active");
	  $("#__stories_10").removeClass("__active");
	  $("#__stories_1").removeClass("__inactive");
	  $("#__stories_2").removeClass("__inactive");
	  $("#__stories_3").removeClass("__inactive");
	  $("#__stories_4").removeClass("__inactive");
	  $("#__stories_5").removeClass("__inactive");
	  $("#__stories_6").removeClass("__inactive");
	  $("#__stories_7").removeClass("__inactive");
	  $("#__stories_8").removeClass("__inactive");
	  $("#__stories_9").removeClass("__inactive");
	  $("#__stories_10").removeClass("__inactive");
	  
	  $("#__stories_description_1").removeClass("__active");
	  $("#__stories_description_2").removeClass("__active");
	  $("#__stories_description_3").removeClass("__active");
	  $("#__stories_description_4").removeClass("__active");
	  $("#__stories_description_5").removeClass("__active");
	  $("#__stories_description_6").removeClass("__active");
	  $("#__stories_description_7").removeClass("__active");
	  $("#__stories_description_8").removeClass("__active");
	  $("#__stories_description_9").removeClass("__active");
	  $("#__stories_description_10").removeClass("__active");
	  $("#__stories_description_1").addClass("__inactive");
	  $("#__stories_description_2").addClass("__inactive");
	  $("#__stories_description_3").addClass("__inactive");
	  $("#__stories_description_4").addClass("__inactive");
	  $("#__stories_description_5").addClass("__inactive");
	  $("#__stories_description_6").addClass("__inactive");
	  $("#__stories_description_7").addClass("__inactive");
	  $("#__stories_description_8").addClass("__inactive");
	  $("#__stories_description_9").addClass("__inactive");
	  $("#__stories_description_10").addClass("__inactive");
  }
  /*stories_init();
  $("#__stories_description_1").css("display","block");
  $("#__stories_frame_1").css("display","block");*/   
  $("#__stories_1").on('click', function(event) {    
    stories_init();
	$("#__stories_description_1").removeClass("__inactive");
	$("#__stories_description_1").addClass("__active");
	$("#__stories_1").addClass("__active");
  });
	
  $("#__stories_2").on('click', function(event) {    
    stories_init();
	$("#__stories_description_2").removeClass("__inactive");
    $("#__stories_description_2").addClass("__active");
	$("#__stories_2").addClass("__active");
  });
	
  $("#__stories_3").on('click', function(event) {    
    stories_init();
	$("#__stories_description_3").removeClass("__inactive");
    $("#__stories_description_3").addClass("__active");
	$("#__stories_3").addClass("__active");
  });
	
  $("#__stories_4").on('click', function(event) {    
    stories_init();
	$("#__stories_description_4").removeClass("__inactive");
    $("#__stories_description_4").addClass("__active");
	$("#__stories_4").addClass("__active");
  });
	
  $("#__stories_5").on('click', function(event) {    
    stories_init();
	$("#__stories_description_5").removeClass("__inactive");
    $("#__stories_description_5").addClass("__active");
	$("#__stories_5").addClass("__active");
  });
	
  $("#__stories_6").on('click', function(event) {    
    stories_init();
	$("#__stories_description_6").removeClass("__inactive");
    $("#__stories_description_6").addClass("__active");
	$("#__stories_6").addClass("__active");
  });
	
  $("#__stories_7").on('click', function(event) {    
    stories_init();
	$("#__stories_description_7").removeClass("__inactive");
    $("#__stories_description_7").addClass("__active");
	$("#__stories_7").addClass("__active");
  });
	
  $("#__stories_8").on('click', function(event) {    
    stories_init();
	$("#__stories_description_8").removeClass("__inactive");
    $("#__stories_description_8").addClass("__active");
	$("#__stories_8").addClass("__active");
  });
	
  $("#__stories_9").on('click', function(event) {    
    stories_init();
	$("#__stories_description_9").removeClass("__inactive");
    $("#__stories_description_9").addClass("__active");
	$("#__stories_9").addClass("__active");
  });
	
  $("#__stories_10").on('click', function(event) {    
    stories_init();
	$("#__stories_description_10").removeClass("__inactive");
    $("#__stories_description_10").addClass("__active");
	$("#__stories_10").addClass("__active");
  });
	
	
} ) ( jQuery );